import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from './store/auth-store';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PartnerLayout } from './components/layout/PartnerLayout';
import { Login } from './pages/Login';
import { Search } from './pages/Search';
import { BusinessDetail } from './pages/BusinessDetail';
import { TrainerDetail } from './pages/TrainerDetail';
import { QRBusinessPrint } from './pages/QRBusinessPrint';
import { QRTrainerPrint } from './pages/QRTrainerPrint';

function App() {
  const { initializeAuth } = useAuthStore();

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<ProtectedRoute><PartnerLayout><Search /></PartnerLayout></ProtectedRoute>} />
      <Route path="/business/:id" element={<ProtectedRoute><PartnerLayout><BusinessDetail /></PartnerLayout></ProtectedRoute>} />
      <Route path="/trainer/:id" element={<ProtectedRoute><PartnerLayout><TrainerDetail /></PartnerLayout></ProtectedRoute>} />

      {/* QR print pages — public, no auth needed (only show QR code + name) */}
      <Route path="/qr/business/:id" element={<QRBusinessPrint />} />
      <Route path="/qr/trainer/:id" element={<QRTrainerPrint />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
